import * as actions from '../actions/actions';

/*
{
  error: null,

  regions: [] || action.regions,
  types: [] || action.types,
  authors: [] || action.authors,
  dates: [] || action.dates,

  report: action.report,
}
*/
export default (state = {}, action) => {
  switch (action.type) {
    case actions.ANALYTICS_VIEWS_INITIAL_DATA_SUCCESS:
      return {
        ...state,
        error: null,
        regions: action.regions,
        types: action.types,
        authors: action.authors,
        dates: action.dates,
      };

    case actions.ANALYTICS_VIEWS_INITIAL_DATA_FAILURE:
      return {
        ...state,
        error: action.error,
        regions: [],
        types: [],
        authors: [],
        dates: [],
      };

    case actions.ANALYTICS_VIEWS_REPORT_SUCCESS:
      return {
        ...state,
        error: null,
        viewsReport: action.report,
      };

    case actions.ANALYTICS_VIEWS_REPORT_FAILURE:
      return {
        ...state,
        error: action.error,
        viewsReport: null,
      };

    case actions.ANALYTICS_RESET_ERROR_STATE:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};
